import {participantResultType} from "../../types/Api/ParticipantResultType";
import {participant} from "../participant";
import {modelHydrator} from "./_modelHydrator";
import {raceHydrator} from "./raceHydrator";

export const participantHydrator = {
  hydrate: (participant: participantResultType): participant => {
    return Object.assign({
      participantId: participant.participantId,
      name: participant.name,
      rank: participant.rank ?? undefined,
      race: participant.race ? raceHydrator.hydrate(participant.race) : undefined,
    }, modelHydrator.hydrate(participant))
  }
}